const {
    markdownToTxt
} = require('markdown-to-txt')
const lodash = require('lodash')

export class Node {
    constructor(id, title, type = null, data = {}) {
        this.id = id;
        this.title = title;
        this.type = type;
        this.childrens = [];
        this.parentId = data.section
    }
}

export class SectionNode extends Node {
    constructor(id, title, type = null, data = {}) {
        super(id, title, type, data)
        this.id = id;
        this.title = title;
        this.type = type;
        this.childrens = [];
        this.parentId = data.parent
        this.versions = data.version
        this.activeTitle = data.version[0].pivot.title
    }
}

export class ArticleNode extends Node {
    constructor(id, title, type = null, data = {}) {
        super(id, title, type, data)
        this.id = id;
        this.title = title;
        this.type = type;
        this.childrens = [];
        this.keywords = data.keywords
        this.folder = data.folder
        this.parentId = data.section

        this.activeVersion = undefined
        this.activeNormative = undefined

        this.versions = data.versions

        this.versions.forEach(version => {
            if (version.version.begin) {
                const [year, month, day] = version.version.begin.split('-').map(Number)
                let date = new Date(year, month - 1, day)
                date.setHours(23, 59, 59, 59)
                version.validity_start = date
            }
            if (version.version.end) {
                const [year, month, day] = version.version.end.split('-').map(Number)
                let date = new Date(year, month - 1, day)
                date.setHours(23, 59, 59, 59)
                version.validity_end = date
            } else {
                let today = new Date();
                today.setDate(today.getDate())
                today.setHours(23, 59, 59, 59)
                version.validity_end = today
            }
        });

        this.versions = this.versions.sort((a, b) => a.validity_start - b.validity_start).reverse()
        this.versions[0].validity_end = new Date(); //imposta il fine della validità a oggi per l'ultima versione disponibile

        //inizializza le versioni come non filtrate
        if (this.versions.length > 0) {
            this.versions[0].filtered = false
        }

        this.markdown = ""
    }
}

export class ContentTree {
    constructor(data) {
        this.filtered = false
        this.nodes = this.buildTree(data);
        this.unfilteredNodes = lodash.cloneDeep(this.nodes)
        this.unordedData = {}
        this.unordedData["sections"] = {}
        for (let i = 0; i < data.sections.length; i++) {
            this.unordedData["sections"][data.sections[i].id] = data.sections[i]
        }
        this.unordedData["articles"] = {}
        for (let i = 0; i < data.articles.length; i++) {
            this.unordedData["articles"][data.articles[i].id] = data.articles[i]
        }
    }

    chunk(chunkSize) {
        var chunks = []
        var nodes = lodash.cloneDeep(this.nodes)
        for (let i = 0; i < this.nodes.length; i += chunkSize) {
            const chunk = nodes.slice(i, i + chunkSize);
            chunks.push(chunk)
        }
        return chunks
    }

    filterBySearch = (node, input, date) => {
        node.childrens.forEach((child) => {
            this.filterBySearch(child, input, date)
        })
        if (node.type == "content") {
            node.versions.forEach((version) => {
                version.filtered = false

                var matchedKeywords = false
                input.split(',').forEach((keyword) => {
                    if (node.keywords.includes(keyword)) {
                        matchedKeywords = true
                    }
                })

                if (date != "") {
                    let d = date.split("/");
                    let searchDate = new Date(d[2] + '/' + d[1] + '/' + d[0]);
                    if (version.validity_start > searchDate || version.validity_end < searchDate) {
                        version.filtered = true
                    }
                }

                if (!node.title.toLowerCase().includes(input.toLowerCase()) && !(version.plainText).toLowerCase().includes(input.toLowerCase()) && !matchedKeywords) {
                    version.filtered = true
                }
            })
        }
    }

    setUnfiltered = () => {
        this.filtered = false
        this.nodes = lodash.cloneDeep(this.unfilteredNodes)
    }

    search = async (input, date) => {
        this.filtered = true
        await this.loadAllContents()
        this.nodes = lodash.cloneDeep(this.unfilteredNodes)
        this.nodes.forEach((node) => {
            this.filterBySearch(node, input, date)
        })
    }

    filterBySearchResults = async (results) => {
        results["active"] = results.articles.map(article => article.id)
        results["parsed_results"] = {}
        results.articles.forEach(article => {
            results["parsed_results"][article.id] = article
        })
        this.filtered = true
        this.nodes = lodash.cloneDeep(this.unfilteredNodes)
        this.nodes.forEach((node) => {
            node = this.filterContents(node, results);
        })
    }

    filterContents = (node, results) => {
        if (node.type == "section") {
            node.childrens.forEach((child) => {
                child = this.filterContents(child, results);
            })
            node.versions.forEach((v) => {
                v.filtered = !results.active_versions.includes(v.pivot.version);
            })
            node.activeTitle = "";
            if (node.versions.length > 0) {
                let av = node.versions.filter((v) => {
                    return !v.filtered
                })
                if (av.length > 0) {
                    node.activeTitle = av[0].pivot.title
                }
            }
        }
        if (node.type == "content") {
            if (node.versions.length == 1) {
                node.versions[0].filtered = false
            }
            if (!results.active.includes(node.id)) {
                node.filtered = true;
                node.versions.forEach((version) => {
                    version.filtered = true
                })
            } else {
                const activeVersions = results.parsed_results[node.id].versions.map(v => v.version.id)
                node.versions.forEach((version) => {
                    version.filtered = !activeVersions.includes(version.version.id)
                })
            }
        }
        if (node.type == "section") {
            let hide = true
            node.childrens.forEach((child) => {
                if (!child.filtered) {
                    hide = false
                }
            })
            node.filtered = hide
        }
        return node;
    }

    loadNodeContents = async (node) => {
        for (const child of node.childrens) {
            await this.loadNodeContents(child); // Attendi il caricamento dei figli
        }

        if (node.type === "content") {
            for (const version of node.versions) {
                try {
                    const content = await node.getVersionContent(version.id);
                    version.plainText = markdownToTxt(content);
                } catch (error) {
                    console.error(`Errore nel caricamento di plainText per la versione ${version.id}:`, error);
                }
            }
        }
    };

    loadAllContents = async () => {
        this.nodes = lodash.cloneDeep(this.unfilteredNodes);

        for (const node of this.nodes) {
            await this.loadNodeContents(node); // Attendi il caricamento dei contenuti di ogni nodo
        }

        this.unfilteredNodes = lodash.cloneDeep(this.nodes);
    };

    getNodeById = (node, nodeId) => {
        if (node.id === nodeId) {
            return node;
        }
        for (const child of node.childrens) {
            const result = this.getNodeById(child, nodeId)
            if (result) {
                return result;
            }
        }
        return null
    }

    getSectionById = (node, nodeId) => {
        if (node.id === nodeId && node.type === "section") {
            return node;
        }
        for (const child of node.childrens) {
            const result = this.getSectionById(child, nodeId)
            if (result) {
                return result;
            }
        }
        return null
    }

    getNodeParent = (node) => {
        let _node = undefined
        if (node.parentId) { //se si tratta di un ArticleNode
            if (this.unordedData.sections[node.parentId]) {
                _node = this.unordedData.sections[node.parentId]
            }
        } else { //altrimenti se si tratta di un oggetto semplice
            _node = this.unordedData.sections[node.parent]
        }
        if (_node) { //se è stato trovato il nodo trova la sua chiave di riferimento
            let _parent = undefined
            _parent = this.unordedData.sections
            if (_node.parentId) {
                _parent = this.unordedData.sections[_node.parent]
            }
            for (const [key, val] of Object.entries(_parent)) {
                if (val === _node) {
                    _node.id = key
                    _node.route = `index.html?section=${_node.id}`
                }
            }
        }
        return _node;
    }

    getChain = (article) => {
        let chain = [];
        chain.push(article);
        let parent = this.getNodeParent(article)
        while (parent != undefined) {
            chain.push(parent)
            parent = this.getNodeParent(parent)
        }
        chain.reverse()
        return chain
    }

    buildTree(data) {
        const sections = data.sections;
        const contents = data.articles;

        // Helper function to recursively create a node and its children
        const createNode = (id, title, sections, contents, type = null, data = {}) => {
            const node = new SectionNode(id, title, type, data);
            // if (node.parentId) {
            //     let currentParent = this.getNodeParent(node)
            //     print(currentPar)
            // }

            // Add section children
            for (const [sectionId, section] of Object.entries(sections)) {
                if (section.parent === id) {
                    const childNode = createNode(section.id, section.title, sections, contents, "section", section);
                    node.childrens.push(childNode);
                }
            }

            // Add content children
            if (contents) {
                for (const [contentId, content] of Object.entries(contents)) {
                    if (content.section === id) {
                        const contentNode = new ArticleNode(content.id, content.title, "content", content);
                        node.childrens.push(contentNode);
                    }
                }
            }

            return node;
        };

        // Find root sections (those with no parent)
        let rootNodes = [];
        for (const [sectionId, section] of Object.entries(sections)) {
            if (!section.parent) {
                const rootNode = createNode(section.id, section.title, sections, contents, "section", section);
                rootNodes.push(rootNode);
            }
        }

        const sortChildrens = (node) => {
            node.childrens.sort((a, b) => {
                return ((a.versions) && a.versions.length > 0 ? a.versions[0].order : 0) - ((b.versions) && b.versions.length > 0 ? b.versions[0].order : 0);
            });
            node.childrens.forEach(child => {
                sortChildrens(child);
            });
        };

        const sortSections = (node) => {
            if (node.type == "section") {
                node.childrens.sort((a, b) => {
                    if (a.type == "article" || b.type == "article") {
                        return 0
                    }
                    let ao = 0;
                    let bo = 0;
                    if (a.versions && a.versions.length > 0 && a.versions[a.versions.length - 1].pivot && a.versions[a.versions.length - 1].pivot.order) {
                        ao = a.versions[a.versions.length - 1].pivot.order
                    }
                    if (b.versions && b.versions.length > 0 && b.versions[b.versions.length - 1].pivot && b.versions[b.versions.length - 1].pivot.order) {
                        bo = b.versions[b.versions.length - 1].pivot.order
                    }
                    return ao - bo
                });
                node.childrens.forEach((child) => {
                    if (child.type == "section") {
                        sortSections(child)
                    }
                });
            }
        }


        rootNodes.forEach(node => {
            sortChildrens(node);
        });
        rootNodes.forEach(node => {
            sortSections(node);
        });
        rootNodes = rootNodes.sort((a, b) => {
            return a.versions[a.versions.length - 1].pivot.order - b.versions[b.versions.length - 1].pivot.order
        })

        return rootNodes;
    }
}

export async function loadOpinions(article, component) { //TODO: correggi il caricamento dei quesiti
    try {
        const response = await fetch(`${component.$root.config.VUE_APP_BACKOFFICE_URL}/article/question/${article.id}/${article.activeVersion.id}`)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        const opinions = await response.json()
        if (opinions.status == "success") {
            opinions.data.forEach(opinion => {
                opinion.content = JSON.parse(opinion.content);
            })
            return opinions.data
        }
    } catch (error) {
        console.log(error.message)
    }
    return [];
}